
const { Core, Utils, DOMEvents } = Global;
const { $fetch, $replaceContent, $active } = Utils;

const ENTER_KEYCODE = 13;

const animationsComplete = element =>
  Promise.allSettled(
    element.getAnimations().map(animation => 
      animation.finished))

customElements.define('modal-container', class extends Core {
    elements = {
        $: ['dialog', 'content', 'spinner']
    }

    propTypes = {
        'remote-url': String,
        'remote-target': String,
        'remote-detach': Boolean,
        'top-layer': Boolean,
    }

    render() {
        this.$('dialog', {
            click: this._handleBackdropClick
        })

        this.$({
            'modal-close': this._close,
            'modal-open': this._open,
            'modal-show': this._open,
        })
    }

    open() {
        this.dispatchEvent(DOMEvents[this.prop('top-layer') ? 'MODAL_OPEN' : 'MODAL_SHOW']);
    }

    close() {
        this.dispatchEvent(DOMEvents.MODAL_CLOSE);
    }

    refreshLayer() {
        this.$('dialog').close();
        this.$('dialog').showModal();
    }

    _handleBackdropClick({ target }) {
        if(this.prop('top-layer') && target === this.$('dialog')) {
            this.dispatchEvent(DOMEvents.MODAL_CLOSE);
        }
    }
    
    async _loadRemoteContent() {
        try {
            this.$remoteContent = await $fetch(this.prop('remote-url'), {
                before: this._loading(true),
                after: this._loading(false),
                select: this.prop('remote-target')
            });
        } catch(err) {
            console.error(err);
        }
    }

    _loading(state) {
        return () => {
            $active(this.$('spinner'), state);
        }
    }

    _attachRemoteContent() {
        if(this.$remoteContent) {
            this.$('content').append(this.$remoteContent);
        }
    }

    _detachRemoteContent() {
        if(this.$remoteContent && this.prop('remote-detach')) {
            this.$remoteContent.remove();
        }
    }

    async _handleRemoteContent() {
        if(this.prop('remote-url') && this.prop('remote-target') && !this.$remoteContent) {
            await this._loadRemoteContent();
        }

        this._attachRemoteContent();
    }

    async _open(e) {

        await this.callBackAtAddToCart();
        if(this.$('dialog').open) {
            return;
        }

        this.$('dialog')[e.type === 'modal-open' ? 'showModal': 'show']();

        await this._handleRemoteContent();
        this.setAttribute('opening', '');

        await animationsComplete(this.$('content')); 
        this.removeAttribute('opening');

        this.$('dialog').dispatchEvent(new CustomEvent(e.type, {
            bubbles: true
        }))
    }

 
 

async callBackAtAddToCart() {
    try {
        console.log('Modal opened - updating prices...');
        
    
        const priceUpdatePromise = typeof window.debouncedPriceUpdate === 'function' 
            ? window.debouncedPriceUpdate() 
            : window.updateCartPrices ? window.updateCartPrices() : Promise.resolve();
            
       
        const timeoutPromise = new Promise((resolve) => {
            setTimeout(resolve, 8000); 
        });
        
        await Promise.race([priceUpdatePromise, timeoutPromise]);
        
        console.log('Modal price update completed');
    } catch (error) {
        console.error('Modal price update failed:', error);
 
        this.showModalFallbackPrices();
    }
}

 
showModalFallbackPrices() {
    this.querySelectorAll('.price-loading, .subtotal-loading').forEach(el => {
        el.style.display = 'none';
    });
    
    this.querySelectorAll('.price-fallback, .subtotal-fallback').forEach(el => {
        el.style.display = 'inline';
    });
}


    async getUpdatedPrice() {
        let subTotal = 0;

        const scriptEl = document.querySelector("#web-pixels-manager-setup");

    
            const raw = scriptEl.textContent;
 
            const match = raw.match(/initData:\s*(\{.*?\}),\s*\}/s);

            if (match) {
            try {
                const initDataStr = match[1];
                const initData = JSON.parse(initDataStr);
 
                const lines = initData.cart?.lines || [];

              
                const titleSkuMap = new Map();

                lines.forEach(line => {
                const title = line.merchandise?.product?.title || "Unknown Title";
                const sku = line.merchandise?.sku || "Unknown SKU";
                titleSkuMap.set(title, sku);
                });

                console.log("Title → SKU Map:", titleSkuMap);

          
                console.log(titleSkuMap.get("DUET SERIES 1/8 SIZE VIOLIN CASE")); 

         


                const productElements = document.querySelector('.\\#cart-drawer-products');
     
                const ajaxCalls = [];



                productElements.querySelectorAll('.\\#cart-drawer-product').forEach(inputEl => {
                    const titleEl = inputEl.querySelector('h5.\\#product-card-min-title a');
                    const title = titleEl ? titleEl.textContent.trim() : "";

                    const qty = parseInt(inputEl.querySelector('.\\#cart-drawer-product-qty').textContent.trim(), 10);

                    const imgEl = inputEl.querySelector('img.\\#media-image');
                    const skuId = imgEl.getAttribute("src");
                    const filename = skuId.split('/').pop();
                    let sku = filename.split('_')[0];
                    console.log("sku ----  "+ sku);
                    console.log(title);

                    if (!sku || sku.toLowerCase().includes("max")) {
                        sku = titleSkuMap.get(title);
                        
                        if(sku===undefined){
                            sku=document.querySelector("product-variant-listener").textContent.trim().split(': ')[1];
                        }
                    }

                    const encodedValues = encodeURIComponent(JSON.stringify({
                        "skuAndDomainName": {
                            "productSKU": [sku],
                            "domainName": "ace-products-group.myshopify.com",
                            "tag": window.productTag,
                            "NSID": window.productNSID
                        }
                    }));

                    const ajaxPromise = new Promise((resolve, reject) => {
                        $.ajax({
                            type: 'GET',
                            url: "https://hooks.webbeeglobal.com/NetsuiteSuitetalkWeb/quantity-pricing/product",
                            dataType: 'json',
                            cache: false,
                            data: encodedValues,
                            success: function (data) {
                                try {
                                    const jsonData = JSON.parse(JSON.stringify(data));
                                    if (jsonData['productValues'] && jsonData['productValues'] !== "null") {
                                        const responseJSON = JSON.parse(jsonData['productValues']);
                                        const skuData = responseJSON[sku] || [];
                                        let matchedData = null;

                                        if (qty) {
                                            for (let i = 0; i < skuData.length; i++) {
                                                if (qty >= skuData[i].quantity_min && qty <= skuData[i].quantity_max) {
                                                    matchedData = skuData[i];
                                                    break;
                                                }
                                            }

                                            if (!matchedData && qty > skuData[skuData.length - 1]?.quantity_max) {
                                                matchedData = skuData[skuData.length - 1];
                                            }

                                            if (matchedData) {
                                                console.log("in modal.js updating price")
                                                const unitPrice = parseFloat(matchedData.amount);
                                                inputEl.querySelector('.\\#product-card-min-price').textContent = '$ ' + unitPrice.toFixed(2);
                                                subTotal += unitPrice * qty;
                                            }
                                        }
                                    }

                                    resolve();
                                } catch (err) {
                                    console.error(err);
                                    resolve();
                                }
                            },
                            error: function (xhr, status, error) {
                                console.error("AJAX error:", error);
                                resolve();
                            }
                        });
                    });

                    ajaxCalls.push(ajaxPromise);
                });
                await Promise.all(ajaxCalls);

                const priceEls = document.querySelectorAll('.\\#cart-drawer-subtotal-item-price');
                let discount = 0;
                if (priceEls.length >= 2) {
                    const discountStr = priceEls[1].textContent.trim().replace(/[^0-9.-]+/g, '');
                    discount = parseFloat(discountStr) || 0;
                }

                if (priceEls[0]) {
                    priceEls[0].textContent = '$ ' + subTotal.toFixed(2);
                }
                const finalSubtotalEl = priceEls.length === 3 ? priceEls[2] : priceEls[1];

                if (finalSubtotalEl) {
                    const updatedSubtotal = subTotal + discount;
                    finalSubtotalEl.textContent = '$ ' + updatedSubtotal.toFixed(2);
                }

            } catch (err) {
                console.error("Error parsing initData JSON:", err);
            }
            }

    }

    async _close(e) {
        e?.preventDefault();
        if(!this.$('dialog').open) {
            return;
        }
        this.setAttribute('closing', '');
        await animationsComplete(this.$('content'));
        this.$('dialog').close();
        this.removeAttribute('closing');

        this._detachRemoteContent();
    }
})

customElements.define('modal-open', class extends Core {
    propTypes = {
        target: String,
        fallback: String
    }

    render() {
        this.$target = document
            .getElementById(this.prop('target'))

        this._handleClick();
    }

    async _handleClick() {
        await customElements.whenDefined('modal-container');

        this.$({
            click: this._openTargetModal,
            keydown: this._openOnEnterPressed
        })
    }

    _openOnEnterPressed(e) {
        if(e.keyCode === ENTER_KEYCODE) {
            this._openTargetModal()
        }
    }

    _openTargetModal() {
        if(!this.$target) {
            if(this.prop('fallback')) {
                window.location.href = this.prop('fallback');
            }
            return;
        }
        this.$target.dispatchEvent(DOMEvents.MODAL_OPEN);
    }
})

customElements.define('modal-close', class extends Core {
    render() {
        this.$({
            click: this._emitClose
        })
    }

    _emitClose() {
        this.dispatchEvent(DOMEvents.MODAL_CLOSE);
    }
})